export const customSelectStyles = (hasError) => ({
    control: (provided, state) => ({
        ...provided,
        minHeight: "46px",
        height: "46px",
        fontSize: "1rem",
        fontWeight: 400,
        borderWidth: "1px",
        borderRadius: "6px",
        borderColor: hasError
            ? "#dc3545"
            : state.isFocused
                ? "#4A86E8"
                : provided.borderColor,

        boxShadow: "none", // ✅ remove thick focus glow

        "&:hover": {
            borderColor: hasError
                ? "#dc3545"
                : "#4A86E8",
        },
    }),

    container: (provided) => ({
        ...provided,
        borderRadius: "6px",
    }),

    singleValue: (provided) => ({
        ...provided,
        fontWeight: 400,
    }),

    valueContainer: (provided) => ({
        ...provided,
        height: "46px",
        padding: "0 8px",
        marginLeft: "6px",
    }),

    indicatorsContainer: (provided) => ({
        ...provided,
        height: "46px",
    }),

    placeholder: (provided) => ({
        ...provided,
        color: "#6C757D",
        fontSize: "1rem",
        fontWeight: 400,
        opacity: 0.6,
    }),
});